import { Directive, ElementRef } from '@angular/core';
import { Platform } from '../services/platform';

@Directive({ selector: '[platform]' })
export class PlatformDirective {
    constructor(el: ElementRef, private platform: Platform) {
        el.nativeElement.className += ' ' + this.platform.getPlatform();
    }
}
